import React from 'react'
import {Link, useNavigate} from "react-router-dom";
import Sidebar from "../../../../components/Sidebar";
import PageHeader from "../../../../components/PageHeader";
import "./index.css";
import {toast} from "react-toastify";
import DatePicker, {registerLocale} from "react-datepicker";
import {getSchoolYear, getSchoolYearName} from "../../../../utils/authority";
import StudentController from "../../../../services/system/student/student-controller";
import vi from "date-fns/locale/vi";
import BusRouteController from "../../../../services/system/bus/bus-route-controller";
import GradeManager, {GRADE_ALL} from "../../../../components/Grade";
import ClassRoomController from "../../../../services/data-declaration/class-room-controller";
import {Month} from "../../student/attendance";
import ModalCopyMenuWeek from "./modalCopyMenuWeek";
registerLocale("vi", vi);
function withRouter(Component) {
    return (props) => <Component {...props} navigate={useNavigate()} />;
}
class CreateMenuWeekManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            month: 1,
            year: 2023,
            listYear: [],
            listBuaAn: [
                {
                    "sang": "",
                    "trua": "",
                    "toi": ""
                },
                {
                    "sang": "",
                    "trua": "",
                    "toi": ""
                },
                {
                    "sang": "",
                    "trua": "",
                    "toi": ""
                }
            ],
            listMonAn: [
                {
                    "id": "0",
                    "name": "Tên món ăn 1",
                },
                {
                    "id": "0",
                    "name": "Tên món ăn 2",
                },
            ],
            listDayName: ["Chủ nhật", "Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"],
            listWeek: [],
            allClass: [],
            allGrade: [],
            showInfo: [],

            busRouteId: -1,
            billNumber: 0,
            paidMoneyTotal: 0,
            paidNumber: 0,
            remainMoneyTotal: 0,
            seatNumber: 0,
            seatNumberRegistered: 0,
            listRouteBus: [],
            busTypePriceRes: [],
            priceDiscount: 0,
            noteDiscount: "",
            stateService: "ACTIVE",
            dateStart: new Date(),
            totalMoney: 0,
            busTypePos: -1,
            assistant1Id: -1,
            assistant1Name: "",
            assistant1Username: "",

            assistant2Id: -1,
            assistant2Name: "",
            assistant2Username: "",

            assistant3Id: -1,
            assistant3Name: "",
            assistant3Username: "",
            busStopRes: [],
            busUserServiceRes: [],
            listStudent: [],
            studentName: "",
            studentId: -1,


            activeDate: null,
            content: "",
            pageNumber: 0,
            pageSize: 10,
            header: [
                {
                    id: "0",
                    name: "Thứ, ngày",
                    date: "",
                    style: {textAlign: "center", border: '2px solid #fff'},
                    sort: false
                },
                {
                    id: "t2",
                    name: "Thứ 2",
                    date: "Ngày 23/03/2023",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "t3",
                    name: "Thứ 3",
                    date: "Ngày 23/03/2023",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "t4",
                    name: "Thứ 4",
                    date: "Ngày 23/03/2023",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "t5",
                    name: "Thứ 5",
                    date: "Ngày 23/03/2023",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "t6",
                    name: "Thứ 6",
                    date: "Ngày 23/03/2023",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "t7",
                    name: "Thứ 7",
                    date: "Ngày 23/03/2023",
                    style: {textAlign: "left"},
                    sort: false
                }
            ],
            headerMenu: [
                {
                    id: "0",
                    name: "Thực đơn",
                    date: "",
                    style: {textAlign: "center", border: '2px solid #fff'},
                    sort: false
                },
                {
                    id: "t2",
                    name: "Thứ 2",
                    date: "Ngày 23/03/2023",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "t3",
                    name: "Thứ 3",
                    date: "Ngày 23/03/2023",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "t4",
                    name: "Thứ 4",
                    date: "Ngày 23/03/2023",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "t5",
                    name: "Thứ 5",
                    date: "Ngày 23/03/2023",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "t6",
                    name: "Thứ 6",
                    date: "Ngày 23/03/2023",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "t7",
                    name: "Thứ 7",
                    date: "Ngày 23/03/2023",
                    style: {textAlign: "left"},
                    sort: false
                }
            ]
        };
    }

    componentWillMount() {
        let currentYear = getSchoolYearName();
        if (currentYear != undefined){
            this.state.listYear = currentYear.split("-")
        }
        this.getListRouteBus()
        this.getListStudent()
    }
    getWeekOfMonth() {
        // Lấy ngày của tháng trước
        // Lấy ngày của tháng sau
        let firstOfMonth = new Date(this.state.year, this.state.month-1, 1);
        let lastOfMonth = new Date(this.state.year, this.state.month, 0);
        for (let i = firstOfMonth.getDate(); i< lastOfMonth.getDate()+1; i++){
            let currentDay =  new Date(this.state.year, this.state.month-1, i);
        }
        console.log(firstOfMonth.getDay())
        console.log(lastOfMonth)
        let used = firstOfMonth.getDay() + 6 + lastOfMonth.getDate();
        return Math.ceil( used / 7);
    }
    renderStatus() {
        let listStatus = [
            {
                "id": "All",
                "name": "Tất cả"
            },
            {
                "id": "PENDING",
                "name": "Chưa thanh toán"
            },
            {
                "id": "PAYMENT",
                "name": "Đã thánh toán"
            },

        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    onCreate = () => {
        if (this.state.busRouteId < 0){
            toast.error("Vui lòng chọn tuyến xe bus");
        }else if(this.state.busStopId < 0){
            toast.error("Vui lòng chọn điểm đón/trả");
        }else if(this.state.busTypeId < 0){
            toast.error("Vui lòng chọn dịch vụ xe bus");
        }else if(this.state.month < 1){
            toast.error("Vui lòng chọn số tháng đóng phí");
        }else if(this.state.studentId < 0){
            toast.error("Vui lòng chọn học sinh");
        }
        else {
            let payload = {
                "addressHome": this.state.addressHome,
                "busRouteId": this.state.busRouteId,
                "busStopId": this.state.busStopId,
                "busTypeId": this.state.busTypeId,
                "priceType": this.state.month,
                "studentId": this.state.studentId
            }
            BusRouteController.registerBusUserService(payload, res => {
                if (res.success){
                    toast.success("Đăng ký thành công!")
                    this.setState({
                        showLoading: false,
                    });
                } else {
                    toast.error("Đã xảy ra lỗi! " + res.message)
                }
            })
        }
    }

    getListRouteBus() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            assistant1Name: "",
            busRouteName: "",
            driverName: "",
            pageNumber: 0,
            pageSize: 100,
            sort: "created_at desc",
            state: "ACTIVE",
        };
        BusRouteController.search(payload, res => {
            this.setState({
                showLoading: false,
                listRouteBus: res.data.content,
            });
        })
    }
    getListStudent() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            classRoomId: -1,
            code: "",
            ethnic: "",
            fullName: this.state.studentName,
            gender: "",
            grade: "",
            pageNumber:0,
            pageSize: 100,
            sort: "created_at desc",
            studentState: "",
        };
        StudentController.search(payload, res => {
            this.setState({
                listStudent: res.data.content,
            });
        })
    }
    hideComponent = (index) => {
        this.state.showInfo[index] = !this.state.showInfo[index]
        if (this.state.showInfo[index]){
            let gradeInfo = GRADE_ALL[index]
            if (gradeInfo != undefined){
                this.getListClassByGrade(gradeInfo.id)
            }
        }

        this.setState({
            showInfo:  this.state.showInfo
        })
    }
    getListClassByGrade = (gradeId) => {
        let payload = {
            name: "",
            grade: gradeId,
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 100,
            "sort": "created_at desc"
        };
        ClassRoomController.search(payload, res => {
            if (res.success){
                this.state.allClass[gradeId] =  res.data.content
            }
        })
    };
    renderAllGroup=() =>{
        let allClass = this.state.allClass
        return GRADE_ALL.map((grade, indexX) =>
            <div className="col-6 d-flex mb-2 row">
                <button type="button"  style={{border: "none"}} className="col-12 p-2 mb-2 bg-info bg-gradient text-white  d-block py-2 no-border-top d-flex justify-content-between align-items-center"  onClick={() => this.hideComponent(indexX)}>
                        <span style={{textAlign: "left"}}>
                            {grade.name}
                        </span>
                    {this.state.showInfo[indexX] ?<span className="fas fa-angle-down icon-arrow-side-bar" aria-hidden="true"></span>:<span className="fas fa-angle-up icon-arrow-side-bar" aria-hidden="true"></span>}
                </button>
                {this.state.showInfo[indexX] &&
                    <div className="col-12 d-flex mb-2 row" style={{paddingLeft: "0px", paddingRight: "0px"}}>
                        {
                            this.state.allClass[grade.id]?.map((classInfo, subIndex) =>
                                <div className="col-3 d-flex mb-2 row">
                                    <input
                                        type="checkbox"
                                        maxLength={255}
                                        checked={classInfo.isClick}
                                        className="form-control shadow-none check-box-type"
                                        onChange={(event) => {
                                            classInfo.isClick = !classInfo.isClick
                                            this.setState({
                                                allClass:  allClass
                                            })
                                        }}
                                    /> <label className="txt-bold mb-3">{classInfo.name}</label>
                                </div>
                            )
                        }
                    </div>}
            </div>
        )
    }
    renderHeader(){
        return (
            <tr>
                {this.state.header.map((obj, i) => {
                    obj.style = {
                        ...obj.style,
                        backgroundColor: '#c6e6f1',
                        color: 'black',
                        verticalAlign: "middle",
                        minWidth: obj.style.minWidth ? obj.style.minWidth : '60px',
                        fontWeight: 'normal'
                    };
                    return (
                        <th style={obj.style}
                            onMouseOver={() => {
                                this.setState({hover: true, index: i})
                            }} onMouseOut={() => {
                            this.setState({hover: false, index: null})
                        }} scope="col" onClick={() => {
                            if (obj.sort) this.clickSort(obj, i)
                        }}>
                            <div className="d-flex justify-content-center">
                                <div>
                                    <a style={{color: 'black'}}>{obj.name}</a>
                                    <div style={{color: 'black'}}>{obj.date}</div>
                                </div>
                                {obj.sort &&
                                <div style={{verticalAlign: "middle"}}>
                                    <i style={{color: this.hoverColor(obj, i), cursor: "pointer", marginLeft: 3}} className={this.ascendingStyle(obj)}/>
                                </div>}
                            </div>
                        </th>
                    )
                })}
            </tr>
        );
    }
    renderMenu(){
        return (
            <tr>
                {this.state.headerMenu.map((obj, i) => {
                    obj.style = {
                        ...obj.style,
                        backgroundColor: '#c6e6f1',
                        color: 'black',
                        verticalAlign: "middle",
                        minWidth: obj.style.minWidth ? obj.style.minWidth : '60px',
                        fontWeight: 'normal'
                    };
                    return (
                        <th style={obj.style}
                                       onMouseOver={() => {
                                           this.setState({hover: true, index: i})
                                       }} onMouseOut={() => {
                            this.setState({hover: false, index: null})
                        }} scope="col" onClick={() => {
                            if (obj.sort) this.clickSort(obj, i)
                        }}>
                            <div className="d-flex justify-content-center">
                                <div>
                                    { obj.id == "0" && <a style={{color: 'black'}}>{obj.name}</a>}
                                    { obj.id != "0" && <input
                                        placeholder="Tên/Mã thực đơn"
                                        maxLength={255} type="text"
                                        className="form-control shadow-none"
                                        value={this.state.title}
                                        onChange={(event) => {
                                            this.setState({
                                                title: event.target.value
                                            })
                                        }}
                                    />}
                                </div>
                            </div>
                        </th>
                    )
                })}
            </tr>
        );
    }
    renderYear() {
        return this.state.listYear.map((item, index) => <option
            value={item}>{item}</option>)
    }
    renderMonth() {
        return Month.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    render() {
        let {header, headerMonAn, listBuaAn, listMonAn} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="menu-week" parentClass="menu-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Quản lý thực đơn tuần"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-3 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Năm</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.year}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            year: e.target.value
                                                        })
                                                    }}
                                                >
                                                    {this.renderYear()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-3 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tháng</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.month}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            month: e.target.value
                                                        }, ()=>{
                                                            let week = this.getWeekOfMonth()
                                                            console.log(week)
                                                        })
                                                    }}
                                                >
                                                    {this.renderMonth()}
                                                </select>
                                            </div>
                                            <button
                                                type="button"
                                                className="col-xs-3 col-sm-3 col-md-1 customer_state_potential border-1-s mr-1 background-btn type-button-fix btn btn-primary btn-sm shadow-none position"
                                                title='Tuần 1'
                                            >
                                                Tuần 1
                                            </button>
                                            <button
                                                type="button"
                                                className="col-xs-3 col-sm-3 col-md-1 customer_state_potential border-1-s mr-1 background-btn type-button-fix btn btn-primary btn-sm shadow-none position"
                                                title='Tuần 2'
                                            >
                                                Tuần 2
                                            </button>
                                            <button
                                                type="button"
                                                className="col-xs-3 col-sm-3 col-md-1 customer_state_potential border-1-s mr-1 background-btn type-button-fix btn btn-primary btn-sm shadow-none position"
                                                title='Tuần 3'
                                            >
                                                Tuần 3
                                            </button>
                                            <button
                                                type="button"
                                                className="col-xs-3 col-sm-3 col-md-1 customer_state_potential border-1-s mr-1 background-btn type-button-fix btn btn-primary btn-sm shadow-none position"
                                                title='Tuần 4'
                                            >
                                                Tuần 4
                                            </button>
                                            <button
                                                type="button"
                                                className="col-xs-3 col-sm-3 col-md-1 customer_state_potential border-1-s mr-1 background-btn type-button-fix btn btn-primary btn-sm shadow-none position"
                                                title='Tuần 5'
                                            >
                                                Tuần 5
                                            </button>
                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2 center-message">
                                                <b>Thực đơn tuần 1 từ 23/3/2023-30/03/2023 của nhóm ăn A</b>
                                            </div>
                                            <div className="card col-12">
                                                <div className="p-0 mb-3">
                                                    <div className="table-wrapper">
                                                        <table
                                                            className="table table-striped table-data table-responsive table-bordered">
                                                            <table className="table">
                                                                <thead>
                                                                {this.renderHeader()}
                                                                </thead>
                                                                {this.renderMenu()}
                                                                {!listBuaAn ||
                                                                listBuaAn.length == 0 ? (
                                                                    <tbody>
                                                                    <tr>
                                                                        <td colSpan={12}>
                                                                            <div className="text-center">
                                                                                Không có dữ liệu
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                ) : (
                                                                    <tbody>
                                                                    {listBuaAn &&
                                                                    listBuaAn.length > 0 &&
                                                                    listBuaAn?.map((row, index) => (
                                                                        <tr style={{height: 50}}>
                                                                            <td style={{textAlign: "center", padding: 0}} scope="row">
                                                                                Sáng
                                                                            </td>
                                                                            <td style={{textAlign: "center", padding: 0}} scope="row">
                                                                                <div className="food-name">Cơm</div>
                                                                                <div className="food-name">Cháo</div>
                                                                                <div className="food-name">Sữa</div>
                                                                            </td>
                                                                            <td style={{textAlign: "center", padding: 0}} scope="row">
                                                                                <div className="food-name">Cơm</div>
                                                                                <div className="food-name">Cháo</div>
                                                                                <div className="food-name">Sữa</div>
                                                                            </td>
                                                                            <td style={{textAlign: "center", padding: 0}} scope="row">
                                                                                <div className="food-name">Cơm</div>
                                                                                <div className="food-name">Cháo</div>
                                                                                <div className="food-name">Sữa</div>
                                                                            </td>
                                                                            <td style={{textAlign: "center", padding: 0}} scope="row">
                                                                                <div className="food-name">Cơm</div>
                                                                                <div className="food-name">Cháo</div>
                                                                                <div className="food-name">Sữa</div>
                                                                            </td>
                                                                            <td style={{textAlign: "center", padding: 0}} scope="row">
                                                                                <div className="food-name">Cơm</div>
                                                                                <div className="food-name">Cháo</div>
                                                                                <div className="food-name">Sữa</div>
                                                                            </td>
                                                                            <td style={{textAlign: "center", padding: 0}} scope="row">
                                                                                <div className="food-name">Cơm</div>
                                                                                <div className="food-name">Cháo</div>
                                                                                <div className="food-name">Sữa</div>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                    </tbody>
                                                                )}
                                                            </table>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="align-right col-12">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                            disabled={this.state.fullName == ""}
                                            onClick={()=> {
                                                this.onCreate()
                                            }}
                                        >
                                            Lưu
                                        </button>
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s background-btn type-button-fix btn btn-info shadow-none"
                                            disabled={this.state.fullName == ""}
                                            onClick={() => {
                                                this.setState({ showModalCopy: true})
                                            }}
                                        >
                                            Sao chép
                                        </button>
                                        <button
                                            type="button"
                                            className="ml-4  border-1-s type-button-fix btn btn-light shadow-none"
                                        >
                                            <Link
                                                style={{color: '#000'}}
                                                to={{
                                                    pathname: "/ad-sas-school/danh-sach-dang-ky-xe-bus"
                                                }}
                                            >
                                                Hủy bỏ
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalCopyMenuWeek
                    show={this.state.showModalCopy}
                    onHide={() => this.setState({showModalCopy: false})}
                    onRefresh={() => this.onhandleSearch()}
                    id={this.state.itemSelected}
                />
            </div>
        )
    }
}
export default withRouter(CreateMenuWeekManagement)